<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/accountancy')">Contabilidad</li>
        <li class="breadcrumb-item active" aria-current="page">Catálogo de Bancos</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row justify-content-md-center" style="margin-top:20px;">
        <div class="col-md-12">
          <md-card>
            <md-card-content>
              <md-table style="text-align: center">
                <md-table-row>
                  <md-table-head style="text-align: center">Institución</md-table-head>
                  <md-table-head style="text-align: center">CLABE</md-table-head>
                  <md-table-head style="text-align: center">Propia o T</md-table-head>
                  <md-table-head style="text-align: center">Clave Contable</md-table-head>
                  <md-table-head style="text-align: center">Acción</md-table-head>
                </md-table-row>

                <md-table-row v-for="bank in catalog" :key="bank.bcid">
                  <md-table-cell v-if="edit!==bank.bcid">{{bank.bank}}</md-table-cell>
                  <md-table-cell v-else>
                    <md-field>
                      <label>Banco</label>
                      <md-select v-model="new_bank" style="width: 60%">
                        <md-option v-for="inst in banks" :key="inst.id" :value="inst.id">{{inst.short_name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>

                  <md-table-cell v-if="edit!==bank.bcid">{{bank.clabe}}</md-table-cell>
                  <md-table-cell v-else>
                    <md-field>
                      <label>CLABE</label>
                      <md-input v-model="new_clabe"/>
                    </md-field>
                  </md-table-cell>

                  <md-table-cell v-if="edit!==bank.bcid">{{bank.own_or_third}}</md-table-cell>
                  <md-table-cell v-else>
                    <md-radio v-model="new_oot" value="P">P</md-radio>
                    <md-radio v-model="new_oot" value="T">T</md-radio>
                  </md-table-cell>

                  <md-table-cell v-if="edit!==bank.bcid">{{bank.accounting_key}}</md-table-cell>
                  <md-table-cell v-else>
                    <md-field>
                      <label>Clave Contable</label>
                      <md-input v-model="new_key" maxlength="16"/>
                    </md-field>
                  </md-table-cell>

                  <md-table-cell>
                    <md-button class="md-icon-button md-raised md-primary" v-if="edit!==bank.bcid" v-on:click="editar(bank)"><md-icon>edit</md-icon></md-button>
                    <md-button class="md-icon-button md-raised" v-else v-on:click="guardar(bank)"><md-icon>save</md-icon></md-button>
                    <md-button class="md-icon-button md-raised" v-if="edit===bank.bcid" v-on:click="vaciar()"><md-icon>clear</md-icon></md-button>
                  </md-table-cell>
                </md-table-row>

                <md-table-row v-if="edit===-1">
                  <md-table-cell>
                    <md-field>
                      <label>Banco</label>
                      <md-select v-model="new_bank" style="width: 60%">
                        <md-option v-for="inst in banks" :key="inst.id" :value="inst.id">{{inst.short_name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>CLABE</label>
                      <md-input v-model="new_clabe"/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-radio v-model="new_oot" value="P">P</md-radio>
                    <md-radio v-model="new_oot" value="T">T</md-radio>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Clave Contable</label>
                      <md-input v-model="new_key"/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-button class="md-icon-button md-raised" v-on:click="guardar()"><md-icon>save</md-icon></md-button>
                    <md-button class="md-icon-button md-raised" v-on:click="vaciar()"><md-icon>clear</md-icon></md-button>
                  </md-table-cell>
                </md-table-row>

              </md-table>
            </md-card-content>

            <md-card-actions v-if="edit === false">
              <md-button class="md-icon-button md-raised md-primary" style="background-color: green" v-on:click="edit=-1">
                <md-icon>add</md-icon>
              </md-button>
            </md-card-actions>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
  export default  {
    name: 'banks-catalog',
    props: [],
    mounted() {
      axios.get( '/api/accounting/banks').then(response => {
        this.banks = response.data.data;
        axios.get( '/api/accounting/banks/catalog').then(response => {
          this.catalog = response.data.data;
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('No se ha podido cargar el catálogo', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      }).catch(error => {
        Vue.toasted.clear();
        Vue.toasted.show('No se ha podido cargar la lista de Instituciones Bancarias', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
      });
    },
    data() {
      return {
        banks: [],
        catalog: [],
        edit: false,
        new_bank: null,
        new_clabe: null,
        new_oot: null,
        new_key: null,
      }
    },
    methods: {
      vaciar(){
        this.edit = false;
        this.new_bank = null;
        this.new_clabe = null;
        this.new_oot = null;
        this.new_key = null;
      },
      guardar(bank = null){
        Vue.toasted.show('Guardando...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/accounting/banks/catalog/save', {
          id: this.edit,
          bank_id: this.new_bank,
          clabe: this.new_clabe,
          own_or_third: this.new_oot,
          accounting_key: this.new_key
        }).then(response => {
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Banco guardado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
          this.vaciar();
          axios.get( '/api/accounting/banks/catalog').then(response => {
            this.catalog = response.data.data;
          }).catch(error => {
            Vue.toasted.clear();
            Vue.toasted.show('No se ha podido cargar el catálogo', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
          });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      editar(bank){
        this.edit = bank.bcid;
        this.new_bank = bank.bid;
        this.new_clabe = bank.clabe;
        this.new_oot = bank.own_or_third;
        this.new_key = bank.accounting_key;
      }
    },
    computed: {

    },
}
</script>

<style scoped lang="scss">
  .banks-catalog {

  }
</style>
